import { requestWithToken } from "../utils/apis";

export const fetchFormList = async (page, limit, search = "", sort, order) => {
  try {
    let url = `/api/form/list?page=${page}&limit=${limit}`;

    if (search) url += `&search=${search}`;
    if (sort) url += `&sort=${sort}`;
    if (order) url += `&order=${order}`;

    const response = await requestWithToken("GET", url);
    return response.data;

  } catch (err) {
    return err?.response?.data;
  }
};
export const saveForm = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      "/api/form",
      payload
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Something went wrong",
    };
  }
};
export const DeleteForm = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
      `/api/form/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to Delete template",
    };
  }
};
export const fetchFormById = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/form/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to fetch form",
    };
  }
};
export const UpdateForm = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/form/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to update template",
    };
  }
};
export const fetchFormDetailList = async (page, limit, type, search = "", sort, order,) => {
  try {
    let url = `/api/form-data/list?page=${page}&limit=${limit}&type=${type}`;

    if (search) url += `&search=${search}`;
    if (sort) url += `&sort=${sort}`;
    if (order) url += `&order=${order}`;

    const response = await requestWithToken("GET", url);
    return response.data;

  } catch (err) {
    return err?.response?.data;
  }
};
export const fetchFormData = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/form-data/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to fetch form",
    };
  }
};
export const exportFormCSV = async (type) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/form-data/export/csv?type=${type}`,
      null,
      { responseType: "blob" } 
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const putReadData = async (id) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/form-data/read/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to fetch form",
    };
  }
};

export const deleteFormData = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
      `/api/form-data/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to fetch form",
    };
  }
};

export const fetchBlogCategoryList = async (page, limit,search, sort, order,) => {
  try {
    let url = `/api/blog_category/list?page=${page}&limit=${limit}`;

    if (search) url += `&search=${search}`;
    if (sort) url += `&sort=${sort}`;
    if (order) url += `&order=${order}`;

    const response = await requestWithToken("GET", url);
    return response.data;

  } catch (err) {
    return err?.response?.data;
  }
};